import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/app/[locale]/(header-footer)/category/[slug]/ArticleList/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/ui/components/Heading/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/ui/components/LanguageOptionsSetter.tsx");
